import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface HeroBackgroundSettings {
  id: number;
  background_image_url: string | null;
  overlay_opacity: number;
  is_active: boolean;
  youtube_video_url: string | null;
}

export const useHeroBackground = () => {
  const [settings, setSettings] = useState<HeroBackgroundSettings | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      console.log('🔍 [useHeroBackground] Buscando configurações...');
      
      const { data, error } = await supabase
        .from('hero_background_settings')
        .select('*')
        .eq('is_active', true)
        .single();

      if (error) {
        console.error('❌ [useHeroBackground] Erro:', error);
        setSettings(null);
      } else {
        console.log('✅ [useHeroBackground] Configurações carregadas:', data);
        setSettings(data);
      }
    } catch (error) {
      console.error('❌ [useHeroBackground] Erro inesperado:', error);
      setSettings(null);
    } finally {
      setLoading(false);
    }
  };

  return {
    settings,
    loading,
    refetch: fetchSettings
  };
}; 